export class CopyToClipboard {
    copyButtonNode: HTMLElement | null = document.querySelector('a[href="#copy"]');

    constructor() {
        if (!this.copyButtonNode) {
            return;
        }

        this.copyButtonNode.addEventListener('click', (event: Event) => {
            event.preventDefault();
            const target = event.currentTarget as HTMLElement;
            const originalContent = target.innerHTML;

            void navigator.clipboard.writeText(window.location.href).then(() => {
                target.innerHTML = '<svg width="20" height="20" class="fill-[currentcolor]" aria-hidden="true"><use xlink:href="/dist/svg-sprite/sprite.svg?v=11#check"></use></svg>';
                setTimeout(() => {
                    target.innerHTML = originalContent;
                }, 3000);
            });
        });
    }
}